<template>
  <div>
      <v-row align="center" justify="center">
        <v-col cols="12" sm="11" md="8">
          <v-card v-if="burial">
            <v-card-title class="text-h4">
              Burial
              <v-spacer/>
              <v-icon color="secondary" v-if="shareAvailable" @click="share">mdi-share-variant</v-icon>
            </v-card-title>
            <v-card-text class="text-body-2">
              The burial of <em class="font-weight-bold">{{deceasedName}}</em> takes place on <b>{{dateTime}}</b> at {{$config.LOCATION}}.
            </v-card-text>
            <v-card-text class="text-body-2">
              The burial plot is located in block <b>{{burial.block_ref}}</b>, row <b>{{burial.row_no}}</b>, site <b>{{burial.site_no}}</b>.
            </v-card-text>
            <v-card-text class="text-body-2">
              <a color="grey" class="grey--text text--darken-1 text-decoration-none" :href="mapsUrl" target="_blank">
                <v-icon color="">mdi-google-maps</v-icon>Click here for a google map link to the burial plot location.
              </a>
            </v-card-text>
          </v-card>
          <v-card v-if="notFound">
            <v-card-title class="text-h4">
              Sorry
            </v-card-title>
            <v-card-text class="text-body-2">
              We couldn't find what you are looking for.
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
  </div>

</template>

<script>

export default {
  name: 'Burial',
  components: {
  },
  props: [],
  data () {
    return {
      burial: null,
      notFound: false
    }
  },
  computed: {
    shareAvailable () {
      return navigator.share
    },
    mapsUrl () {
      if (this.burial) {
        return `https://www.google.com/maps/search/?api=1&query=${this.centroid[1]},${this.centroid[0]}`
      } else {
        return ''
      }
    },
    centroid () {
      if (this.burial) {
        return JSON.parse(this.burial.centroid_json).coordinates
      } else {
        return null
      }
    },
    dateTime () {
      let str = ''
      if (this.burial) {
        str += this.formatD(this.burial.burial_date)
        if (this.burial.burial_slot_from) {
          str += ' between ' + this.formatSlot(this.burial.burial_slot_from) + ' and ' + this.formatSlot(this.burial.burial_slot_to)
        }
      }
      return str
    },
    deceasedName () {
      let str = ''
      if (this.burial) {
        if (this.burial.deceased_salutation) { str += this.burial.deceased_salutation + ' ' }
        if (this.burial.deceased_first_name) { str += this.burial.deceased_first_name + ' ' }
        if (this.burial.deceased_middle_name) { str += this.burial.deceased_middle_name + ' ' }
        if (this.burial.deceased_last_name) { str += this.burial.deceased_last_name }
      }
      return str
    }
  },
  mounted () {
    if (this.$route.params.public_id) {
      this.$http.plain.get('/api/v1/public/burial/' + this.$route.params.public_id)
        .then(res => {
          this.burial = res.data
          document.title = this.$config.APP_TITLE + ' - ' + this.deceasedName + ' - ' + this.formatD(this.burial.burial_date)
        })
        .catch(() => {
          this.notFound = true
        })
    }
  },
  watch: {
  },
  methods: {
    share () {
      if (navigator.share) {
        navigator.share({
          title: 'Burial of ' + this.deceasedName + '. ' + this.dateTime + '.',
          url: window.location.href
        })
      }
    }
  }
}
</script>

<style scoped>

</style>
